(function () {

    "use strict";

    angular.module("sphforms.formacion", [
        // External
        "toaster",
        "ui.router",
		"ngResource",
        "sphforms.main"

    ]);

}());
